import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Verifica se existe window.__RUNTIME_ENVIRONMENT__ para habilitar produção
const runtimeEnv = (window as any).__RUNTIME_ENVIRONMENT__;
const isProduction = runtimeEnv ? runtimeEnv.production === 'true' || runtimeEnv.production === true : environment.production;

if ( isProduction )
{
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
